<template>
  <auth-shell
    :title="$t('auth.reset.title')"
    :subtitle="$t('auth.reset.sub')"
    :back-label="$t('auth.backLogin')"
    icon="fal fa-lock"
    icon-tone="brand"
  >
    <form class="ps-auth-form" novalidate @submit.prevent="submitForm(form)">
      <!-- new password -->
      <div class="ps-field">
        <label class="ps-field__label" for="npPw">{{
          $t("auth.reset.password")
        }}</label>
        <div class="ps-field__pw">
          <input
            id="npPw"
            v-model="form.password"
            :type="showPassword ? 'text' : 'password'"
            required
            :minlength="8"
            autocomplete="new-password"
            :placeholder="$t('auth.reset.passwordPh')"
            class="ps-input"
            :disabled="overlay"
            @input="$v.form.password.$touch()"
            @blur="$v.form.password.$touch()"
          />
          <button
            type="button"
            class="ps-field__eye"
            :aria-label="$t('show_password') || 'Show password'"
            @click="showPassword = !showPassword"
          >
            <v-icon small>{{
              showPassword ? "fal fa-eye-slash" : "fal fa-eye"
            }}</v-icon>
          </button>
        </div>
        <p v-if="passwordErrors.length" class="ps-field__error">
          {{ passwordErrors[0] }}
        </p>
      </div>

      <!-- confirm password -->
      <div class="ps-field">
        <label class="ps-field__label" for="npCf">{{
          $t("auth.reset.confirm")
        }}</label>
        <div class="ps-field__pw">
          <input
            id="npCf"
            v-model="form.confirm_password"
            :type="confirmPassword ? 'text' : 'password'"
            required
            autocomplete="new-password"
            :placeholder="$t('auth.reset.confirmPh')"
            class="ps-input"
            :disabled="overlay"
            @input="$v.form.confirm_password.$touch()"
            @blur="$v.form.confirm_password.$touch()"
          />
          <button
            type="button"
            class="ps-field__eye"
            :aria-label="$t('show_password') || 'Show password'"
            @click="confirmPassword = !confirmPassword"
          >
            <v-icon small>{{
              confirmPassword ? "fal fa-eye-slash" : "fal fa-eye"
            }}</v-icon>
          </button>
        </div>
        <p v-if="confirmPasswordErrors.length" class="ps-field__error">
          {{ confirmPasswordErrors[0] }}
        </p>
      </div>

      <button
        type="submit"
        class="ps-btn ps-btn--lime ps-btn--block ps-auth-submit"
        :disabled="overlay"
      >
        {{ overlay ? "…" : $t("auth.reset.submit") }}
      </button>
    </form>

    <app-loading :overlay="overlay" />
  </auth-shell>
</template>

<script>
import { toast } from "@/controllers/alert";
import { required, minLength, sameAs } from "vuelidate/lib/validators";
import AuthShell from "@/components/auth/AuthShell.vue";

export default {
  name: "NewPasswordPage",
  layout: "blank",
  components: { AuthShell },
  data: () => ({
    overlay: false,
    showPassword: false,
    confirmPassword: false,
    form: {
      password: "",
      confirm_password: "",
    },
  }),
  validations: {
    form: {
      password: { required, minLength: minLength(8) },
      confirm_password: { required, sameAsPassword: sameAs("password") },
    },
  },
  computed: {
    passwordErrors() {
      const errors = [];
      if (!this.$v.form.password.$dirty) return errors;
      !this.$v.form.password.required &&
        errors.push(this.$t("validation_password_required"));
      !this.$v.form.password.minLength &&
        errors.push(this.$t("validation_password_min_length"));
      return errors;
    },
    confirmPasswordErrors() {
      const errors = [];
      if (!this.$v.form.confirm_password.$dirty) return errors;
      !this.$v.form.confirm_password.required &&
        errors.push(this.$t("validation_confirm_password_required"));
      !this.$v.form.confirm_password.sameAsPassword &&
        errors.push(this.$t("validation_password_mismatch"));
      return errors;
    },
  },
  methods: {
    async submitForm(form) {
      try {
        this.$v.form.$touch();
        if (!this.$v.form.$invalid) {
          this.overlay = true;
          const body = {
            email: this.$route.query.email,
            otp: this.$route.query.otp,
            token: this.$route.query.token,
            password: form.password,
            confirm_password: form.confirm_password,
          };
          const { data } = await this.$http.post("new_password", body);
          if (data.status) {
            await toast(this, data.message);
            this.overlay = false;
            this.$router.push("/login");
          }
        }
      } catch (error) {
        this.overlay = false;
        console.log("submitForm ===> ", error);
      }
    },
  },
};
</script>

<style scoped>
.ps-auth-form {
  margin-top: 32px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.ps-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.ps-field__label {
  font-size: 0.875rem;
  font-weight: 900;
  color: var(--ps-ink);
}

.ps-field__pw {
  position: relative;
}
.ps-field__pw .ps-input {
  padding-right: 3rem;
}
.ps-field__eye {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  border: none;
  background: transparent;
  color: var(--ps-slate-400);
  width: 32px;
  height: 32px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.15s ease;
}
.ps-field__eye:hover {
  color: var(--ps-brand);
}

.ps-field__error {
  margin: 0;
  font-size: 12px;
  font-weight: 700;
  color: #dc2626;
}

.ps-auth-submit {
  padding: 1rem;
}
</style>
